import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  code: string().required('Field is required'),
});

export default yupResolver(validationSchema);
